// extracted by mini-css-extract-plugin
export default {"skill_card":"styles_skill_card__ol6FF"};